
import { useEffect, useRef, useState } from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { BaseProps } from "../../components/move-inRegistrationTabs/interfaces";
import { ButtonsContainer } from "../../components/move-inRegistrationTabs/move-inTabs.styled";
import { TabContainer } from "../../components/SocialCaseTbas/Social.styled";

import CloseIcon from "../../assets/CloseIcon.svg";
import styled from "styled-components";


import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import { SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";



interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  //   onVerify:any,
  onClose?: React.MouseEventHandler<HTMLImageElement | HTMLButtonElement>;
  onConfirm: () => void;
  loader: any;
}

const ConfirmationModal = ({ onClose, onConfirm, loader }: Props) => {
  //   useEffect(()=>{
  //     General.sendOTP({errorId: 'sendOTPError', data: {premiseId:null, email, mobile, personID}})
  //   },[])

  return (
    <div style={{ 
      width: General?.isLargeScreen ? "40vw" : '100%', overflow: "auto", margin: "30vh auto", direction: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "rtl" : "ltr", }}>
      <div
        style={{
          // height: '20%',
          
          width: "100%",
          justifyContent: "space-between",
          // paddingLeft: "1rem",
          // paddingRight: "1rem",
          padding: '1rem',
          background: General.contrast?.contrastBackground ? General.contrast?.contrastBackground : General.ColorAss,
          display: "flex",
          alignItems: "center",
        }}

      >
        <h1 style={{ 
          color: General.contrast.contrastColor? General.contrast.contrastColor : "white", 
          justifySelf: "flex-start", 
          fontSize: `${2 * General.accessibility.fontSize}rem` 
          }}>
          {General?.codeLabels["cm_confirm_transfer"]?.label !== undefined ? General?.codeLabels["cm_confirm_transfer"]?.label : "Confirm Transfer"}
        </h1>
        <img src={CloseIcon} alt="" onClick={onClose} />
      </div>
      <TabContainer  style={{
        padding: "2rem",
        display: "flex",
        gap: "0.5rem",
        flexDirection: "column",
        //   justifyContent: "center",
        //   alignItems: "center",
        backgroundColor: General.contrast?.contrastColor ? General.contrast?.contrastColor : "#fff",
        color: General.contrast.contrastBackground ? General.contrast.contrastBackground : General.ColorAss,
      }}>
        <span style={{ fontWeight: '700' }}> {General?.codeLabels["cm_confirmtransfer"]?.label !== undefined ? General?.codeLabels["cm_confirmtransfer"]?.label : "Are you sure to transfer the amount?"}</span>

      </TabContainer>
      <TabContainer
        style={{
          padding: "0.3rem",
          display: "flex",
          gap: "0.5rem",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: General.contrast?.contrastColor ? General.contrast?.contrastColor : "#fff",
          color: General.contrast?.contrastBackground ? General.contrast?.contrastBackground : General.ColorAss,
        }}
      >
        <ButtonsContainer
          style={{ display: "flex", gap: "12px", width: "fit-content" }}
        >
          <ButtonSecondary
            style={{
              width: "45%",
              padding: "auto",
              fontSize: `${General.accessibility.fontSize}rem`,
              borderColor: General.contrast.contrastBackground ? General.contrast.contrastBackground : General.ColorAss,
              color: General.contrast.contrastBackground ? General.contrast.contrastBackground : General.ColorAss,
              background: General.contrast.contrastColor ? General.contrast.contrastColor : "",
            }}
            onClick={onClose}

          >
            {General?.codeLabels["cm_usepassloginpagecancel"]?.label !== undefined ? General?.codeLabels["cm_usepassloginpagecancel"]?.label : "CANCEL"}

          </ButtonSecondary>
          <ButtonSecondary
            style={{
              width: "45%",
              padding: "auto",
              color: General.contrast.contrastColor ? General.contrast.contrastColor : "#fff",
              background: General.contrast.contrastBackground ? General.contrast.contrastBackground : General.ColorAss,
              whiteSpace: "nowrap", fontSize: `${General.accessibility.fontSize}rem`,
              border: 'none'
            }}
            onClick={onConfirm}
          >
            {loader ? <SpinnerRaw width="30px" height="30px" /> : General?.codeLabels["cm_confirm"]?.label !== undefined ? General?.codeLabels["cm_confirm"]?.label : "cm_confirm"}
          </ButtonSecondary>
        </ButtonsContainer>
      </TabContainer>
    </div>
  );
};

export default observer(ConfirmationModal);
